( function( $ ) {
	'use strict';

	// The DOM needs to be fully loaded (including graphics, iframes, etc)
	$( window ).load( function() {
        let header_height = 0;
        if( $("body").hasClass("has-sticky-menu") ){
            header_height = $(".main-navigation").outerHeight();
        }
		$( 'a[href^="#"]' ).click( function(e) {
			var anchor = $( this ).attr( 'href' );
			$( 'html,body' ).animate( { scrollTop: $( anchor ).offset().top - header_height -12 }, 800 );
		});

	});

})( jQuery );
